import { Box, Typography } from '@mui/material'
import { flexItemLeft } from '../../global'
import Webcast from '../../images/ViewAndEdit/Webcast.svg'
import Webinar from '../../images/ViewAndEdit/Webinar.svg'
import Podcast from '../../images/ViewAndEdit/Podcast.svg'

export const EventType = ({
  eventType
}: {
  eventType: string
  setViewAllEvent?: () => void
}) => {
  return (
    <Box sx={{ mb: '1px' }}>
      {eventType === 'Webcast' && (
        <Box
          display='inline'
          style={{ ...flexItemLeft, textTransform: 'none', gap: '8px' }}
        >
          <Box
            component='img'
            src={Webcast}
            alt='Webcast'
            width='16px'
            height='16px'
          />

          <Typography
            fontSize='14px'
            fontWeight={500}
            color='#565656'
            display='inline'
          >
            Webcast
          </Typography>
        </Box>
      )}
      {eventType === 'Podcast' && (
        <Box
          display='inline'
          style={{ ...flexItemLeft, textTransform: 'none', gap: '8px' }}
        >
          <Box
            component='img'
            src={Podcast}
            alt='Podcast'
            width='16px'
            height='16px'
          />

          <Typography
            fontSize='14px'
            lineHeight={'20px'}
            fontWeight={500}
            color='#565656'
            display='inline'
          >
            Podcast
          </Typography>
        </Box>
      )}
      {eventType === 'Webinar' && (
        <Box
          display='inline'
          style={{ ...flexItemLeft, textTransform: 'none', gap: '8px' }}
        >
          <Box
            component='img'
            src={Webinar}
            alt='Webinar'
            width='16px'
            height='16px'
          />

          <Typography
            fontSize='14px'
            fontWeight={500}
            color='#565656'
            display='inline'
          >
            Webinar
          </Typography>
        </Box>
      )}
    </Box>
  )
}
